export default "__VITE_ASSET__BAX4OLNE__"